import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import JobApplicationDetails from "./JobApplicationDetails";
import Button from "../shared/button/Button";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  CloseButton,
  ButtonsWrapper,
} from "./styles/jobs-submitted-for-modal-styles";
import Candidate from "../../apiResources/Candidate";
import Application from "../../apiResources/Application";

export const JobApplicationsModal = (props: Props) => {
  const { candidate, applications, onDismiss } = props;

  return (
    <Backdrop className="animated fadeIn">
      <ModalWrapper className="animated delay-1 fadeInDown">
        <Title>
          <TitleText>{`${candidate.fullName} - jobs submitted for`}</TitleText>
          <CloseButton onClick={onDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </Title>
        <Body>
          {applications.map((application) => (
            <JobApplicationDetails
              key={application.id}
              application={application}
            />
          ))}
        </Body>
        <ButtonsWrapper>
          <Button primary buttonName="Close" onClickAction={onDismiss} />
        </ButtonsWrapper>
      </ModalWrapper>
    </Backdrop>
  );
};

type Props = {
  applications: Application[];
  candidate: Candidate;
  onDismiss: () => void;
};

export default JobApplicationsModal;
